import AccountRequest from '~/utils/infra/account/request'
import BaseRequest from '~/utils/infra/base/request'
import ClientRequest from '~/utils/infra/client/request'
import HamacRequest from '~/utils/infra/hamac/request'
import TransatRequest from '~/utils/infra/transat/request'
import GedRequest from '~/utils/infra/ged/request'
import ExportsRequest from '~/utils/infra/exports/request'
import PrepaPaieRequest from '~/utils/infra/prepa-paie/request'
import CssRequest from '~/utils/infra/css/request'
import AccountAPIError from '~/utils/infra/account/error'
import BaseAPIError from '~/utils/infra/base/error'
import ClientAPIError from '~/utils/infra/client/error'
import HamacAPIError from '~/utils/infra/hamac/error'
import TransatAPIError from '~/utils/infra/transat/error'
import GedAPIError from '~/utils/infra/ged/error'
import ExportsAPIError from '~/utils/infra/exports/error'
import PrepaPaieAPIError from '~/utils/infra/prepa-paie/error'
import CssAPIError from '~/utils/infra/css/error'

/** @constant {object} */
export const ERRORS = {
  UNKNOWN_REQUEST_INSTANCE_TYPE: 'unknown request instance type',
  MAXIMUM_REQUEST_RETRY_REACHED: 'maximum request retry reached',
  ANONYMOUS_REQUEST_THROWED_401: 'anonymous request throwed 401 status code',
  NO_COMPTE_ID_RETRIEVED: 'no compte id has been retrieved in session',
}

/** @constant {number} */
export const MAXIMUM_RETRY_ALLOWED = 2 // (excluded)

/**
 * @desc Exhaustive predicate for GHS `Request`
 * @param {*} request
 * @returns {boolean}
 */
export const isGHSRequest = request => {
  return (request instanceof BaseRequest)
      || (request instanceof AccountRequest)
      || (request instanceof HamacRequest)
      || (request instanceof ClientRequest)
      || (request instanceof TransatRequest)
      || (request instanceof AccountRequest)
      || (request instanceof GedRequest)
      || (request instanceof ExportsRequest)
      || (request instanceof PrepaPaieRequest)
      || (request instanceof CssRequest)

}
/**
 * @desc Exhaustive predicate for GHS `APIError`
 * @param {*} error
 * @returns {boolean}
 */
export const isGHSAPIError = error => {
  return (error instanceof BaseAPIError)
      || (error instanceof AccountAPIError)
      || (error instanceof HamacAPIError)
      || (error instanceof ClientAPIError)
      || (error instanceof TransatAPIError)
      || (error instanceof AccountAPIError)
      || (error instanceof GedAPIError)
      || (error instanceof ExportsAPIError)
      || (error instanceof PrepaPaieAPIError)
      || (error instanceof CssAPIError)
}

//============================================

///
/// Namespace for previous micro-services (eg. hamac)
///
/// Below representation are both as schema for the input/output with the micro
/// services, and for view-model data representation
///

/**
 * @desc Parse a table provider `Context` to our micro service `ListInputSchema`
 * @type {import('./types_').wrap}
 */
export const wrap = src => ({
  // Paginating
  per_page: src.perPage,
  current_page: src.currentPage,
  // Searching
  search: !src.search || src.search === '' || src.search.trim() === '' ? undefined : src.search.trim(),
  // Sorting
  order: !src.order || src.order === '' ? undefined : src.order,
  // @ts-ignore: UNSAFE predicate (ie. runtime robustness)
  sort: !src.sort || src.sort === '' ? undefined : src.sort,
  // Filtering
  filters: src.filters ?? undefined
})

/**
 * Representation of the **output properties** commonly used by our micro
 * services for a filter/pagination route list
 *
 *  - `currentPage` is a one-based index
 *
 * @typedef {Pick<import('./types_').PaginateResume
 *  , "currentPage"
 *  | "from"
 *  | "to"
 *  | "lastPage"
 *  | "perPage"
 *  | "total"
 * >} ListOutputSchema
 */

//============================================

///
/// Namespace for micro services developed from 2025/06 (such as "ged")
///

/**
 * Schema used by some micro services
 * @typedef {{
 *    pagination: PaginationSchema;
 *    sort: SortCollectionSchema;
 * }} OrderedListInputSchema
 *
 * @typedef {object} PaginationSchema
 * @property {number} current_page one-based index
 * @property {number} per_page
 *
 *
 * @typedef {Array<SortEntrySchema>} SortCollectionSchema
 *
 *
 * @typedef {object} SortEntrySchema
 * @property {string} field
 * @property {"DESC"|"ASC"} order
 */

//============================================

